{
  "required": "هذا الحقل مطلوب",
  "email": "البريد الإلكتروني غير صحيح",
  "minLength": "الحد الأدنى {{count}} حرفا",
  "maxLength": "الحد الأقصى {{count}} حرفا",
  "passwordWeak": "كلمة المرور ضعيفة",
  "passwordsMismatch": "كلمتا المرور غير متطابقتين",
  "invalidNumber": "القيمة يجب أن تكون رقما",
  "positiveNumber": "القيمة يجب أن تكون أكبر من صفر",
  "requiredFieldsNote": "الحقول المطلوبة مميزة بعلامة النجمة",
  "numbersOnly": "يسمح بإدخال الأرقام فقط",
  "tooManyDecimals": "يسمح بخمس منازل عشرية كحد أقصى."
}
